import { TimeSlot, TimeSlotStatusEnum } from "@/types/doctor.definition";
import { addDays } from "date-fns";
import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

// Slot dates and times are Africa/Dakar, as in DoctorAvailabilitySelector.
const TIME_ZONE = "Africa/Dakar";
export const SLOT_STATS_DAYS = 7;

/** API date range (yyyy-MM-dd, Dakar) covering the next SLOT_STATS_DAYS days. */
export const slotStatsRange = (now: Date = new Date()) => ({
  startDate: formatInTimeZone(now, TIME_ZONE, "yyyy-MM-dd"),
  endDate: formatInTimeZone(addDays(now, SLOT_STATS_DAYS), TIME_ZONE, "yyyy-MM-dd"),
});

/**
 * MED-1687: counters of the availability page, over the next SLOT_STATS_DAYS days and
 * for this facility only. upcoming counts every status, available only free slots.
 */
export const computeSlotStats = (
  slots: TimeSlot[],
  facilityId: number,
  now: Date = new Date(),
): { available: number; upcoming: number } => {
  const end = addDays(now, SLOT_STATS_DAYS).getTime();
  const upcoming = slots.filter((slot) => {
    if (slot.healthcareFacilityId !== facilityId) return false;
    const start = fromZonedTime(`${slot.slotDate}T${slot.slotStartTime}`, TIME_ZONE).getTime();
    return start >= now.getTime() && start <= end;
  });
  const available = upcoming.filter(
    (slot) => slot.status === TimeSlotStatusEnum.AVAILABLE && !slot.isBooked,
  );
  return { available: available.length, upcoming: upcoming.length };
};
